/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

import MaintenanceSettlement from '../views/maintenance-settlement/ListMerchant.vue';
import MaintenanceSettlementUpload from '../views/maintenance-settlement/UploadMerchant.vue';

import { setBreadcrumb } from './index';

const maintenanceSettlementRoute = {
  path: '/maintenance-settlement',
  meta: {
    title: 'BNI QRIS - Maintenance Settlement',
    appBarTitle: 'Maintenance Settlement',
  },
  component: Parent,
  children: [
    {
      path: '/maintenance-settlement',
      meta: {
        title: 'BNI QRIS - Maintenance Settlement',
        appBarTitle: 'Maintenance Settlement',
        breadcrumbs: () => [
          setBreadcrumb(
            'maintenance settlement',
            '/maintenance-settlement',
            true
          ),
          setBreadcrumb('list merchant', '/maintenance-settlement'),
        ],
      },
      component: MaintenanceSettlement,
      name: 'MaintenanceSettlement',
    },
    {
      path: '/maintenance-settlement/:id/bulk-upload',
      meta: {
        title: 'BNI QRIS - Bulk Upload Maintenance Settlement',
        appBarTitle: 'Bulk Upload Maintenance Settlement',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb(
              'maintenance settlement',
              '/maintenance-settlement',
              true
            ),
            setBreadcrumb('list merchant', '/maintenance-settlement'),
            setBreadcrumb(
              'bulk upload',
              `/maintenance-settlement/${id}/bulk-upload`
            ),
          ];
        },
      },
      component: MaintenanceSettlementUpload,
      name: 'MaintenanceSettlementUpload',
    },
  ],
};
export default maintenanceSettlementRoute;
